import { render, staticRenderFns } from "./quotation-history.vue?vue&type=template&id=dce2f8fc&scoped=true"
import script from "./quotation-history.vue?vue&type=script&lang=js"
export * from "./quotation-history.vue?vue&type=script&lang=js"
import style0 from "./quotation-history.vue?vue&type=style&index=0&id=dce2f8fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce2f8fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dce2f8fc')) {
      api.createRecord('dce2f8fc', component.options)
    } else {
      api.reload('dce2f8fc', component.options)
    }
    module.hot.accept("./quotation-history.vue?vue&type=template&id=dce2f8fc&scoped=true", function () {
      api.rerender('dce2f8fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/quotation-apply-sup/quotation-history.vue"
export default component.exports